import { RoverBrand } from '@rover/types/src/RoverBrand';
import getRoverBrand from '@rover/utilities/getRoverBrand';

import roverLoader from './rover-loader-animation.svg?url';
import catInAFlatLoader from './rover-loader-animation-ciaf.svg?url';

/**
 * Next resolves `?url` imports through its image loader, which hands back an
 * image descriptor rather than the plain string every other bundler emits.
 * Left as the descriptor, the interpolated `url()` is malformed and the browser
 * drops the declaration, so the loader never paints.
 */
const toUrl = (asset: unknown): string => {
  const src = (asset as { src?: unknown } | null)?.src;
  return (typeof src === 'string' ? src : asset) as string;
};

const loaderImageMap: Record<string, string> = {
  [RoverBrand.Rover]: roverLoader,
  [RoverBrand.CatInAFlat]: catInAFlatLoader,
};

const getLoaderImage = (): string => {
  const brand = getRoverBrand();
  return toUrl(loaderImageMap[brand] ?? roverLoader);
};

export default getLoaderImage;
